import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default from 'react';
import DnaSpinner from '../assets/icons/DnaSpinner.esm.js';
import classNames from 'classnames';

var NvSpinner = function (_a) {
    var isLoading = _a.isLoading, _b = _a.classes, classes = _b === void 0 ? {} : _b, _c = _a.size, size = _c === void 0 ? 'large' : _c, _d = _a.fullscreen, fullscreen = _d === void 0 ? false : _d, props = __rest(_a, ["isLoading", "classes", "size", "fullscreen"]);
    return isLoading ? (React__default.createElement("div", __assign({ className: fullscreen ? 'nv-spinner-fullscreen' : '' }, props),
        React__default.createElement("div", { "aria-hidden": "false", "aria-label": "Loading", className: classNames('nv-spinner', classes.root, "nv-spinner-size--".concat(size)), role: "alert" },
            React__default.createElement(DnaSpinner, null)))) : null;
};

export { NvSpinner as default };
//# sourceMappingURL=NvSpinner.esm.js.map
